module.exports = __webpack_public_path__ + "static/media/hr dev. nd training.98c6f204.svg";